import React, {useState, useEffect} from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as styles from './hero.module.scss';
import TextBlock from '../TextBlock/TextBlock'; 
import { Gallery } from '../SectionFeature/gallery';
import Img from "gatsby-image"
const Hero = ({data}) => {
  const {content, image, title, heading, description, alignment } = data;
  let [isDomLoaded, setIsDomLoaded ] = useState(false)
  useEffect(() => {
      setIsDomLoaded(true)
  }, []);
  return (
      <div className={
        `container container-md ${styles.heroWrapper}`} style = {{visibility : isDomLoaded ? "visible" : "hidden"}}>
          {image&&(
            <GatsbyImage
            className={styles.image}
            image={image.gatsbyImageData}
            alt={image.title}
          />
          // <Img fluid={image.fluid} alt={image.title} className={styles.image}/>
        )}
      
      {
        heading==='level-2' ? (
        <h2 className={`heading heading-1 ${styles.title}`}>
         {title ? title.split('/n').map((item:any, id:number) => <span key = {id}>{item} <br/></span> ) : null}
         </h2>
        ) : (
        <h1 className={`heading heading-1 ${styles.title}`}>
          {title ? title.split('/n').map((item:any, id:number) => <span key = {id}>{item} <br/></span> ) : null}
        </h1>
        )}
        {description && (
          <TextBlock 
            data={description} 
            alignment = {alignment}
            />
        )}
        {/* {images && <Gallery data = {{images : images}}/>} */}
      </div>
  );
}
export default Hero